module.exports = __webpack_public_path__ + "img/ko-box.c02ac108.png";